// components/Order.js
import React from 'react';

const Order = () => {
  return (
    <div className="component-container">
      <h2 className="component-title">Order (Pickup)</h2>
      <p className="component-text">Place your pickup order here.</p>
    </div>
  );
};

export default Order;